import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import TextareaCounter from '../../FormComponents/TextareaCounter';

export default function Chats({ details, onChange, disabled, softwares, errors, preferences }) {
  const { isSchemaFetched, schema } = preferences;
  return (
    <div className="chats">
      {schema?.first_message &&
        <div className="chats__row">
          <p className="chats__row__label">
            {schema?.first_message?.description || 'What would you like the first text message to your guest to say?'}
            <sup>*</sup>
            <br />
            <span className="hint-text">
              Note: Please don&apos;t enter phone numbers or URLs as part of this first message.
            </span>
          </p>
          <div className="mandatory__row__input">
            <TextareaCounter
              rows="3"
              placeholder={`Hello, thanks for calling ${softwares.info.STUDIO_NAME || '<name>'}. This is our text-only number for reservations and inquiries.`}
              name="first_message"
              value={details.first_message}
              className={classnames({ 'has-error': errors.first_message })}
              onChange={onChange}
              maxLength={160}
              disabled={disabled}
            />
            <span className="message--small message--error">
              {errors.first_message && errors.first_message.message}
            </span>
          </div>
        </div>}
      {schema?.client_outside_door &&
        <div className="chats__row">
          <p className="chats__row__label">
            {schema?.client_outside_door?.description || 'In case a guest is waiting outside, what would you like TrueLark to say?'}
          </p>
          <div className="chats__row__input">
            <TextareaCounter
              rows="3"
              placeholder="I'm sorry about that.
              I've forwarded your message to the stylist and they'll let you in shortly"
              name="client_outside_door"
              value={details.client_outside_door}
              onChange={onChange}
              maxLength={160}
              disabled={disabled}
            />
          </div>
        </div>
      }
    </div>
  );
}

Chats.defaultProps = {
  onChange: () => { },
  details: {},
  disabled: false,
};

Chats.propTypes = {
  onChange: PropTypes.func,
  details: PropTypes.shape(),
  disabled: PropTypes.bool,
};
